import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/user-actions/UserActionsAction";
import {
  copy,
  DeleteButton,
  ExportButton,
  exportToExcel,
  exportToPDF,
  FormButton,
  getAuthorities,
  noRecordsAlert,
  print,
  redirectToPages,
  resultAlert
} from "../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { StudentUsersFilter } from "./student-users-filter/StudentUsersFilter";
import { StudentUsersTable } from "./student-users-table/StudentUsersTable";
import { useStudentUsersUIContext } from "./StudentUsersUIContext";

export function StudentUsersCard() {
  // Student Users Card UI Context
  const studentUsersUIContext = useStudentUsersUIContext();
  const studentUsersUIProps = useMemo(() => {
    return {
      ids: studentUsersUIContext.ids,
      setIds: studentUsersUIContext.setIds,
      queryParams: studentUsersUIContext.queryParams,
      openIPListEditModal: studentUsersUIContext.openIPListEditModal
    };
  }, [studentUsersUIContext]);

  // Getting curret state of User Actions from store (Redux)
  const { currentState, currentActiveTerm } = useSelector(
    (state) => ({
      currentState: state.userActions,
      currentActiveTerm: state.auth.user.currentActiveTerm
    }),
    shallowEqual
  );  
  const { actionsLoading, isSuccess, type, authorities } = currentState;

  // Authority Parameters
  const { isExportationAuthorized, isEditionAuthorized } = getAuthorities(authorities);

  // Student Users Redux state
  const dispatch = useDispatch();
    
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

/** Belli Bir Öğrenci Kullanıcı Listesini Excele Aktarır */
  const exportStudentUsersToExcel = () => {
    dispatch(actions.getAllStudentUsers(studentUsersUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
        const rows = [];
        const widths = [30, 30, 30, 30, 30, 15];
        const columns = ["TC Kimlik No", "Adı", "Soyadı", "Şube", "Kullanıcı Grubu", "Aktif mi?"];
          
        entities.forEach(entity => rows.push([
          entity.tcKimlikNo,
          entity.name,
          entity.surname,
          entity.section,
          entity.userGroups,
          entity.isActive ? "Aktif" : "Pasif"
        ]));
          
        const filename = currentActiveTerm + " - " + (currentActiveTerm + 1) + " Eğitim Öğretim Yılı Öğrenci Kullanıcı Listesi";
        const sheetname = "Öğrenci Kullanıcı Listesi";
        exportToExcel({ columns, rows, widths, filename, sheetname });
      });
  }
  
  /** Belli Bir Öğrenci Kullanıcı Listesini PDF e Aktarır */
  const exportStudentUsersToPDF = () => {
    dispatch(actions.getAllStudentUsers(studentUsersUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const views = [ 
        {
          header: "TC Kimlik No",
          rows: entities.map(entity => entity.tcKimlikNo)
        },
        {
          header: "Adı",
          rows: entities.map(entity => entity.name)
        },
        {
          header: "Soyadı",
          rows: entities.map(entity => entity.surname)
        },
        {
          header: "Şube",
          rows: entities.map(entity => entity.section)
        },
        {
          header: "Kullanıcı Grubu",
          rows: entities.map(entity => entity.userGroups)
        },
        {
          header: "Aktif mi?",
          rows: entities.map(entity => entity.isActive ? "Aktif" : "Pasif")
        }
      ];
      
      const filename = currentActiveTerm + " - " + (currentActiveTerm + 1) + " Eğitim Öğretim Yılı Öğrenci Kullanıcı Listesi";
      exportToPDF(views, filename);
    });
  }
    
  /** Belli Bir Öğrenci Kullanıcı Listesini Yazdırma Penceresini Açar */
  const printStudentUsers = () => {
    dispatch(actions.getAllStudentUsers(studentUsersUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const data = [];    
      const header = currentActiveTerm + " - " + (currentActiveTerm + 1) + " Eğitim Öğretim Yılı Öğrenci Kullanıcı Listesi";
      const properties = ["TC Kimlik No", "Adı", "Soyadı", "Şube", "Kullanıcı Grubu", "Aktif mi?"];
      
      entities.forEach(entity => {
        data.push({
          "TC Kimlik No": entity.tcKimlikNo,
          "Adı": entity.name,
          "Soyadı": entity.surname,
          "Şube": entity.section,
          "Kullanıcı Grubu": entity.userGroups,
          "Aktif mi?": entity.isActive ? "Aktif" : "Pasif"
        });
      });
      
      print({ data, properties, header });
    });
  }

  /** Belli Bir Öğrenci Kullanıcı Listesini Panoya Kopyalar */
  const copyStudentUsers = () => {
    dispatch(actions.getAllStudentUsers(studentUsersUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const columns = ["TC Kimlik No", "Adı", "Soyadı", "Şube", "Kullanıcı Grubu", "Aktif mi?"];
      const header = currentActiveTerm + " - " + (currentActiveTerm + 1) + " Eğitim Öğretim Yılı Öğrenci Kullanıcı Listesi";
      entities.forEach(entity => rows.push([
        entity.tcKimlikNo,
        entity.name,
        entity.surname,
        entity.section,
        entity.userGroups,
        entity.isActive ? "Aktif" : "Pasif"
      ]));
      copy({ header, columns, rows });
    });
  }

  /** Belli Bir Kullanıcı Listesinin Aktiflik Durumunu Değiştirir */
  const toggleActiveness = (ids) => {
    if (typeof ids === 'string') ids = ids.split(",");
      
    if (ids.length < 1) {
      noRecordsAlert();
      return;
    }
    dispatch(actions.toggleActiveness(ids)).then(result => onResult(result));
  }
      
    const onResult = ({ isSuccess, type, message }) => {
      resultAlert(type, message);
        
      if (isSuccess) {
        setTimeout(() => {
          studentUsersUIProps.setIds([]);
          dispatch(actions.cleanUserActionsState());
          dispatch(actions.getStudentUsers(studentUsersUIProps.queryParams));
        }, 2500);
      }
    };

  const title = <>Öğrenci Kullanıcı Listesi{studentUsersUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{studentUsersUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        {
          (isExportationAuthorized || isEditionAuthorized) &&
          <CardHeaderToolbar>
            {
              isExportationAuthorized &&
              <ExportButton
                exportToExcel={exportStudentUsersToExcel}
                exportToPDF={exportStudentUsersToPDF}
                print={printStudentUsers}
                copy={copyStudentUsers}
              />
            }
            {
              isEditionAuthorized &&
              <>
                <FormButton
                  path="Communication/Write"
                  title="IP Listesi Düzenle"
                  method={() => studentUsersUIProps.openIPListEditModal(studentUsersUIProps.ids)}
                />
                <DeleteButton
                  path="General/Settings-1"
                  title="Aktif Pasif Yap"
                  method={() => toggleActiveness(studentUsersUIProps.ids)}
                />
              </>
            }
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <StudentUsersFilter />
        <StudentUsersTable
          toggleActiveness={toggleActiveness}
        />
      </CardBody>
    </Card>
  );
}